import TopMostPortal from "../../../components/ui/utils/Portals";
import { getEstimaticsCurrentProjectStore } from "../../../data/DataStores";
import { NewProjectWizardStep1 } from "../NewProjectWizard/NewProjectWizardStep1";
import { NewProjectWizardStep2 } from "../NewProjectWizard/NewProjectWizardStep2";
import { NewProjectWizardStep3 } from "../NewProjectWizard/NewProjectWizardStep3";
import { IWizardManager } from "../../../shared/client/GenericWizardStore";
import { useRef } from "react";
import { makeAutoObservable } from "mobx";
import GenericWizardLeftBar from "../../../shared/client/GenericWizardLeftBar";
import GenericWizardRightBar from "../../../shared/client/GenericWizardRightBar";
import { logDebug } from "../../../shared/common/logger";

const initialTitles = ["Project Details", "Documentation"];
class NewProjectWizardManager implements IWizardManager {
	constructor() {
		makeAutoObservable(this);
	}
	private _wizardTitles = [...initialTitles];
	get wizardTitles(): string[] {
		return this._wizardTitles;
	}

	public appendWizardTitle(title: string) {
		if (!this._wizardTitles.includes(title)) {
			this._wizardTitles.push(title);
		}
	}

	wizardStep: number = -1;
	onWizardNext(next: number) {
		this.wizardStep = next;
	}
	onWizardBack() {
		this.wizardStep--;
	}
	onWizardCancel() {
		this.wizardStep = -1;
		this.showWizard = false;
	}
	initWizard() {}

	private _showWizard: boolean = true;
	get showWizard() {
		return this._showWizard;
	}
	set showWizard(value: boolean) {
		this._showWizard = value;
		if (value) {
			this.wizardStep = 1;
			this._wizardTitles = [...initialTitles];
		}
		getEstimaticsCurrentProjectStore().setEstimaticData(value);
	}
}

const _wizardManager: NewProjectWizardManager = new NewProjectWizardManager();
const getWizardManager = () => _wizardManager;
export { getWizardManager };

const NewProjectModal = () => {
	const steps = [NewProjectWizardStep1, NewProjectWizardStep2];
	return (
		<TopMostPortal
			onBackgroundClick={() => {
				const result = window.confirm("Are you sure you want to close? You will lose all unsaved data.");
				if (result) {
					getWizardManager().onWizardCancel();
				}
			}}
		>
			<div className="w-full h-full justify-end flex">
				<div className="w-[960px]  bg-red-100 flex">
					<GenericWizardLeftBar manager={getWizardManager()} />
					<GenericWizardRightBar manager={getWizardManager()} steps={steps} />
				</div>
			</div>
		</TopMostPortal>
	);
};

export default NewProjectModal;
